// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
exports.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Lato:wght@100;300;400;700;900);"]);
// Module
exports.push([module.id, ".v-data-footer[data-v-52ea175e]{justify-content:center}.data-table__pre-header[data-v-52ea175e]{border-bottom:1px solid var(--pale-sky-blue)}.lt-map[data-v-52ea175e]{height:100%}@media screen and (max-width:960px){.lt-map[data-v-52ea175e]{height:100vh}}.fill-height-or-more[data-v-52ea175e]{display:flex;flex-direction:column}.fill-height-or-more>div[data-v-52ea175e]{flex:1}", ""]);
// Exports
module.exports = exports;
